import React from "react";
import { Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";

interface ActionBtnsCellRendererProps {
  onEdit: () => void;
}

const ActionBtnsCellRenderer: React.FC<ActionBtnsCellRendererProps> = ({ onEdit }) => {
  const handleEditClick = () => {
    onEdit();
  };

  return (
    <div style={{ display: "flex" }}>
      <OverlayTrigger placement="bottom" overlay={<Tooltip>Edit mapping</Tooltip>}>
        <Button className="icon-button" onClick={handleEditClick}>
          <Icon.PencilSquare />
        </Button>
      </OverlayTrigger>
    </div>
  );
};

export default ActionBtnsCellRenderer;
